import React, { ReactElement } from 'react'
import {
  Box,
  BoxProps,
  Flex,
  Icon,
  IconType,
  Text,
} from '@mindfulchefuk/design-system'
import { CMSBanner } from '@mindfulchefuk/features/CMS/interfaces'
import { OnboardingChooseRecipesBannerImage } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesBanner/OnboardingChooseRecipesBannerImage/OnboardingChooseRecipesBannerImage'

type TBannerCallout = {
  icon: IconType
  id: string
  copy: string
} & BoxProps

const BannerCallout = ({ icon, id, copy, ...props }: TBannerCallout) => {
  return (
    <Flex id={id} {...props}>
      <Icon
        type={icon}
        color="aubergine"
        size={{ base: 24, md: 28 }}
        flexShrink={0}
      />

      <Text
        variant={{ base: 'body-sm', md: 'body-lg' }}
        color="pepper"
        ml={{ base: 8, md: 16 }}
        id={`${id}-copy`}
      >
        {copy}
      </Text>
    </Flex>
  )
}

export type TOnboardingChooseRecipesBanner = {
  banner: CMSBanner | null
}

export const OnboardingChooseRecipesBanner = ({
  banner,
}: TOnboardingChooseRecipesBanner): ReactElement => (
  <Flex flexDirection={{ base: 'column', sm: 'row' }}>
    <Box>
      <OnboardingChooseRecipesBannerImage banner={banner} />
    </Box>
    <Box
      backgroundColor="salt"
      justifyContent="center"
      paddingY={{ base: 16, lg: 24 }}
      paddingX={[24, 16, 16, 24]}
      minWidth={['auto', 240, '398px', '526px']}
    >
      <BannerCallout
        id="choose-recipes-text-protein"
        icon="heart"
        copy="Delicious, high quality protein - and lots of it"
      />
      <BannerCallout
        id="choose-recipes-text-refined-carbs"
        icon="gluten-free"
        copy="No stodgy refined carbs - no carb comas here"
        my={{ base: 12, lg: 36 }}
      />
      <BannerCallout
        id="choose-recipes-text-fibre"
        icon="soil"
        copy="Goodness from natural food. Plenty of veg - full of fibre"
      />
    </Box>
  </Flex>
)
